import { Bot } from 'lucide-react'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import { Badge } from '@/components/ui/badge'
import { STAGE_LABELS } from './agentLabels'
import type { AgentClaim } from '@/types/agent'

dayjs.extend(relativeTime)

/** The ticket's banner while an Agent Relay agent works it: what it is doing and for how long. Staff only. */
export function ClaimBanner({ claim }: { claim: AgentClaim }) {
  return (
    <div
      role="status"
      data-testid="agent-claim-banner"
      className="mx-6 mt-2 flex items-center gap-2 rounded-etn-card bg-etn-info-subtle px-3.5 py-2 text-etn-control text-etn-info-text"
    >
      <Bot className="h-4 w-4 shrink-0" aria-hidden />
      <span className="font-semibold">
        {claim.agentName}: {STAGE_LABELS[claim.stage]}
      </span>
      <span className="ml-auto text-etn-micro">for {dayjs(claim.since).fromNow(true)}</span>
    </div>
  )
}

/** The queue row's pill for a ticket an agent is working. */
export function AgentQueuePill({ claim }: { claim: AgentClaim }) {
  return (
    <Badge variant="info" className="shrink-0" data-testid="agent-queue-pill" title={`${claim.agentName}: ${STAGE_LABELS[claim.stage]}`}>
      <Bot aria-hidden />
      Agent {STAGE_LABELS[claim.stage]}
    </Badge>
  )
}
